"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/styles");
var CrudeLightBox_1 = __importDefault(require("../../../../shared/components/CrudeComponents/CrudeLightBox"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../../store/crude/crude.selector");
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var Backspace_1 = __importDefault(require("@mui/icons-material/Backspace"));
var Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
var HighlightOff_1 = __importDefault(require("@mui/icons-material/HighlightOff"));
var schemaTypes_1 = require("../../../../shared/types/schemaTypes");
var FileIconComponent_1 = __importDefault(require("../../../../shared/components/CrudeComponents/FileIconComponent"));
var messageTypes_1 = require("../../../../shared/types/messageTypes");
var DialogComponent_1 = __importDefault(require("../../../../shared/components/MessageComponents/DialogComponent"));
var react_i18next_1 = require("react-i18next");
var Download_1 = __importDefault(require("@mui/icons-material/Download"));
var loadFile_1 = __importDefault(require("../../../../fetch/loadFile"));
var getFetchHeaders_1 = __importDefault(require("../../../../shared/util/getFetchHeaders"));
var translateMessage_1 = __importDefault(require("../../../../shared/util/translateMessage"));
var crudeActions = __importStar(require("../../../../store/crude/crude.actions"));
var loadFilePreview_1 = __importDefault(require("../../../../fetch/loadFilePreview"));
var loadFileMetaData_1 = __importDefault(require("../../../../fetch/loadFileMetaData"));
var getOutputLabelFromBytes_1 = __importDefault(require("../../../../shared/util/getOutputLabelFromBytes"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    preview: {
        cursor: 'pointer',
        width: '80px',
        height: 'auto',
        marginRight: '20px',
        borderRadius: '5px',
    },
    previewBox: {
        display: 'flex',
        width: '100%',
        height: '80px',
        overflow: 'hidden',
        justifyContent: 'flex-start',
        alignItems: 'center',
        margin: '20px 20px 0 0',
    },
    lightBox: {
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        marginTop: '10px',
    },
    previewIcon: {
        width: '80px',
        minWidth: '80px',
        height: '80px',
        backgroundColor: theme.palette.grey.A200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '20px',
        borderRadius: '5px',
    },
}); });
var CrudeFilePreview = function (props) {
    var _a, _b, _c, _d;
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var dispatch = react_redux_1.useDispatch();
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var fetchHeaders = crudeConfig.api.headers ? getFetchHeaders_1.default(crudeConfig.api.headers) : {};
    var columnName = props.schema.name;
    var fileMainType = props.schema.columnSubType ? props.schema.columnSubType : schemaTypes_1.ColumnSubType.Document;
    var _e = react_1.useState(), filePreview = _e[0], setFilePreview = _e[1];
    var _f = react_1.useState(), metaData = _f[0], setMetaData = _f[1];
    var _g = react_1.useState(false), openLightBox = _g[0], setOpenLightBox = _g[1];
    var _h = react_1.useState(false), openDeleteDialog = _h[0], setOpenDeleteDialog = _h[1];
    var getImage = function (file) {
        var reader = new FileReader();
        reader.onload = function () {
            setFilePreview(reader.result);
        };
        reader.readAsDataURL(file);
    };
    // Todo set subType from extension
    var fileSubType = undefined;
    var _j = react_1.useState(), file = _j[0], setFile = _j[1];
    var _k = react_1.useState(undefined), fileView = _k[0], setFileView = _k[1];
    var _l = react_1.useState(), fetchResponse = _l[0], setFetchResponse = _l[1];
    react_1.useEffect(function () {
        loadFileMetaData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, props.entity, props.id, fetchHeaders, columnName, setMetaData, setFetchResponse);
        if (props.previewFile) {
            getImage(props.previewFile);
        }
        else {
            if (fileMainType === schemaTypes_1.ColumnSubType.Image) {
                loadFilePreview_1.default(crudeConfig.api.restPath, crudeConfig.api.app, props.entity, props.id, fetchHeaders, columnName, setFilePreview, setFetchResponse);
            }
        }
    }, []);
    react_1.useEffect(function () {
        if (fetchResponse) {
            if (fetchResponse.status && fetchResponse.status < 400) {
                setFileView(filePreview);
            }
            if (fetchResponse.message && crudeLabels) {
                var text = translateMessage_1.default(fetchResponse.message, crudeLabels, props.entity);
                var message = {
                    eventType: fetchResponse.eventType,
                    severity: fetchResponse.status && fetchResponse.status < 400 ? messageTypes_1.Severity.success : messageTypes_1.Severity.error,
                    message: text,
                };
                fetchResponse && dispatch(crudeActions.addMessage(message));
            }
        }
    }, [fetchResponse]);
    var startDownload = function () {
        if (file) {
            var link = document.createElement('a');
            link.href = file;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };
    react_1.useEffect(function () {
        startDownload();
    }, [file]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Box, { component: 'div', className: classes.previewBox },
            filePreview &&
                react_1.default.createElement("img", { onClick: function () {
                        if (!fileView) {
                            if (file) {
                                setFileView(file);
                            }
                            else {
                                loadFile_1.default(crudeConfig.api.restPath, crudeConfig.api.app, props.entity, props.id, fetchHeaders, props.schema.name, setFileView, setFetchResponse);
                            }
                        }
                        else {
                            setOpenLightBox(true);
                        }
                    }, className: classes.preview, src: filePreview }),
            !filePreview &&
                react_1.default.createElement(material_1.Box, { className: classes.previewIcon },
                    react_1.default.createElement(FileIconComponent_1.default, { fileMainType: fileMainType, fileSubType: fileSubType, width: '40px' })),
            react_1.default.createElement(react_1.default.Fragment, null, metaData
                ? (react_1.default.createElement(material_1.Grid, { container: true },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(material_1.Typography, { variant: 'body2' }, metaData.fileName)),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(material_1.Typography, { variant: 'body2' }, metaData.fileSizeInBytes && getOutputLabelFromBytes_1.default(metaData.fileSizeInBytes)))))
                : react_1.default.createElement(material_1.Typography, null, props.id)),
            react_1.default.createElement(material_1.IconButton, { onClick: function () {
                    if (!file) {
                        if (fileView) {
                            setFile(fileView);
                        }
                        else {
                            loadFile_1.default(crudeConfig.api.restPath, crudeConfig.api.app, props.entity, props.id, fetchHeaders, props.schema.name, setFile, setFetchResponse);
                        }
                    }
                    else {
                        startDownload();
                    }
                } },
                react_1.default.createElement(Download_1.default, null)),
            react_1.default.createElement(material_1.IconButton, { onClick: function () { return setOpenDeleteDialog(true); } },
                ((_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.deleteIcon) === 'delete' &&
                    react_1.default.createElement(Delete_1.default, null),
                ((_b = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _b === void 0 ? void 0 : _b.deleteIcon) === 'backspace' &&
                    react_1.default.createElement(Backspace_1.default, null),
                ((_c = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _c === void 0 ? void 0 : _c.deleteIcon) === 'clear' &&
                    react_1.default.createElement(Clear_1.default, null),
                ((_d = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _d === void 0 ? void 0 : _d.deleteIcon) === 'highlightOff' &&
                    react_1.default.createElement(HighlightOff_1.default, null))),
        react_1.default.createElement(material_1.Box, { component: 'div', className: classes.lightBox },
            react_1.default.createElement(CrudeLightBox_1.default, { isOpen: openLightBox, src: fileView, onClose: function () { return setOpenLightBox(false); } })),
        react_1.default.createElement(DialogComponent_1.default, { message: t('crude:deleteFileQuestion'), title: t('crude:deleteFileQuestionTitle'), open: openDeleteDialog, request: true, severity: messageTypes_1.Severity.warning, onClose: function () { return setOpenDeleteDialog(false); }, confirmLabel: t('crude:delete'), autoClose: false, onConfirm: (function () { return props.deleteElement && props.deleteElement(props.id); }), onCancel: function () { return setOpenDeleteDialog(false); } })));
};
exports.default = CrudeFilePreview;
